import { rd, RemoteData } from '@passionware/monads';
import { ensureError } from '@passionware/platform-js';
import { ReactNode } from 'react';
import { Skeleton } from 'v5/design-system/Skeleton';

export interface EntityHeaderActionsProps {
  actions: RemoteData<ReactNode>;
}

export const EntityHeaderActions = ({ actions }: EntityHeaderActionsProps) => {
  return (
    <div className="flex gap-2">
      {rd
        .journey(actions)
        .wait(
          <>
            <Skeleton className="size-9" />
            <Skeleton className="size-9" />
            <Skeleton className="size-9" />
          </>
        )
        .catch(error => (
          <div className="text-fg-danger text-sm">
            {ensureError(error).message}
          </div>
        ))
        .map(actions => actions)}
    </div>
  );
};
